<template>
  <div class="day-chips">
    <v-chip-group :value="selection" @change="$emit('update:selection', $event)">
      <v-chip
        v-for="day in days"
        :key="day.offset"
        :color="chip == day.offset ? 'primary' : ''"
        @click="$emit('select', day.offset)"
      >{{ day.label }}</v-chip>
    </v-chip-group>
  </div>
</template>

<script>
// Quick-pick chips (yesterday / today / tomorrow / day after tomorrow).
//  - `chip`: the day offset currently loaded (highlighted in the primary color).
//  - `selection`: index of the chip-group selection. It is owned by the screen (`.sync`) because
//    the screens re-create this component every time they show their loading spinner.
//  - `select` is emitted with the clicked day offset.
export default {
  name: "DayChips",
  props: {
    chip: { type: Number, default: 0 },
    // No default on purpose: `undefined` means "nothing selected" (a selected chip was clicked again).
    selection: Number,
  },
  data() {
    return {
      days: [
        { label: "أمس", offset: -1 },
        { label: "اليوم", offset: 0 },
        { label: "الغد", offset: 1 },
        { label: "بعد الغد", offset: 2 },
      ],
    };
  },
};
</script>
